import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Checkbox,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import axios from "axios";
import baseUrl from "../../config/baseUrl";

export default function TeamsPermission({ ID, role }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const auth = sessionStorage.getItem("user");

    const merchant = [
        { id: "submerchant", label: "Sub Merchant", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "deposits", label: "Deposits", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "payouts", label: "Payouts", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "refund_chargebacks", label: "Refunds & Chargebacks", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "single_payout", label: "Single Payout", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "settlements", label: "Settlements", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "wallet_logs", label: "Wallet Logs", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "reports", label: "Reports", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "statements", label: "Statements", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "teams", label: "Teams", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
        { id: "buisness_setting", label: "Buisness Setting", enabled: false, permissions: { add: false, edit: false, view: false, delete: false, download: false } },
    ];
    const [permissions, setPermissions] = useState(merchant);

    const handleClickOpen = () => {
        setOpen(true);
        fetchData()
    };

    const handleClose = () => setOpen(false);

    const handleModuleCheckboxChange = (moduleId) => (event) => {
        const updatedPermissions = permissions.map((module) =>
            module.id === moduleId
                ? { ...module, enabled: event.target.checked }
                : module
        );
        setPermissions(updatedPermissions);
    };
    

    const handlePermissionCheckboxChange = (moduleId, permission) => (event) => {
        const updatedPermissions = permissions.map((module) =>
            module.id === moduleId
                ? {
                      ...module,
                      permissions: {
                          ...module.permissions,
                          [permission]: event.target.checked,
                      },
                  }
                : module
        );
        setPermissions(updatedPermissions);
    };
    

    const fetchData = async () => {
        try {
            const values = { id: ID };
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${auth}`,
                },
            };
            const result = await axios.post(`${baseUrl}/getEmployeePermission`, values, config);
        
            const fetchedPermissions = result.data.permissions;
            // console.log(fetchedPermissions);
            
            // Ensure both Admin and Settlement modules have their permissions mapped correctly
            const updatedPermissions = permissions.map((module) => {
            
                const matchingPermission = fetchedPermissions.find(
                    (perm) => perm.module.toLowerCase().includes(module.label.toLowerCase())
                );
            
                if (matchingPermission) {
                    return {
                        ...module,
                        enabled: matchingPermission.status === 1,
                        permissions: {
                            add: matchingPermission.m_add === 1,
                            edit: matchingPermission.m_edit === 1,
                            view: matchingPermission.m_view === 1,
                            delete: matchingPermission.m_delete === 1,
                            download: matchingPermission.m_download === 1,
                        },
                    };
                }
            
                return module;
            });
    
            setPermissions(updatedPermissions);  // Update the state with the new permissions data
        } catch (error) {
            console.error("Error fetching permissions:", error);
        }
    };
    

    const handleSave = async () => {
        setLoading(true);
        try {
            const values = { id: ID, actionData: permissions };
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${auth}`,
                },
            };
    
            await axios.post(`${baseUrl}/permissionEmployee`, values, config);
            alert("Permissions saved successfully!");
            setLoading(false);
            setOpen(false);
            handleClose(); 
            window.location.reload();
        } catch (error) {
            console.error("Error saving permissions:", error);
            alert("Failed to save permissions. Please try again.");
            window.location.reload();
        }
    };

    useEffect(() => {
        
    }, [role]);

    return (
        <React.Fragment>
            <Button
                variant="contained"
                color="primary"
                onClick={handleClickOpen}
                size="small"
                sx={{ marginTop: 2 }}
            >
                Permissions
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
                aria-labelledby="responsive-dialog-title"
                sx={{ zIndex: 1600 }}
            >
                <DialogTitle>
                    <Box
                        component="div"
                        textAlign="center"
                        sx={{
                            textTransform: "uppercase",
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                        }}
                    >
                        Employee Permissions
                    </Box>
                    <button
                        style={{
                            position: 'absolute',
                            top: '22px',
                            right: '10px',
                            background: '#ff6600',
                            border: 'none',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            padding: '5px',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={handleClose}
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-x"
                            style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            }}
                        >
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        </button>
                </DialogTitle>

                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table aria-label="permissions table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Module</TableCell>
                                    <TableCell align="center">Enabled</TableCell>
                                    <TableCell align="center">Add</TableCell>
                                    <TableCell align="center">Edit</TableCell>
                                    <TableCell align="center">View</TableCell>
                                    <TableCell align="center">Delete</TableCell>
                                    <TableCell align="center">Download</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {permissions.map((module) => (
                                    <TableRow key={module.id}>
                                        <TableCell>{module.label}</TableCell>
                                        <TableCell align="center">
                                            <Checkbox
                                                checked={module.enabled}
                                                onChange={handleModuleCheckboxChange(module.id)}
                                            />
                                        </TableCell>
                                        {Object.keys(module.permissions).map((permission) => (
                                            <TableCell align="center" key={permission}>
                                                <Checkbox
                                                    checked={module.permissions[permission]}
                                                    onChange={handlePermissionCheckboxChange(module.id, permission)}
                                                    disabled={!module.enabled}
                                                />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleSave}
                        variant="contained"
                        color="success"
                        size="large"
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}